import * as React from 'react';
import Checkbox from 'components/Checkbox';
import Text from 'components/Text';
import Row from 'components/Row';

type Props = {
  label: string;
  sublabel?: string;
  italicSublabel?: string;
  schoolDefault?: string;
  checked?: boolean;
  onChange?: (event: React.MouseEvent) => void;
  disabled?: boolean;
};

const renderCheckboxSubtextComponent = (
  testName: string,
  innerText: string,
  isItalic?: boolean
) => (
  <Text
    data-test={testName}
    element="div"
    color="graphite"
    size="xsmall"
    align="left"
    weight="normal"
    lineHeight="xlarge"
    italic={isItalic}>
    {innerText}
  </Text>
);

const GroupOptionsCheckbox = (props: Props) => {
  return (
    <Row>
      <Checkbox checked={props.checked} disabled={props.disabled} onChange={props.onChange}>
        <Text data-test="GroupOptionsCheckbox-title" element="div">
          {props.label}
        </Text>
        {props.sublabel &&
          renderCheckboxSubtextComponent('GroupOptionsCheckbox-sublabel', props.sublabel)}
        {props.italicSublabel &&
          renderCheckboxSubtextComponent(
            'GroupOptionsCheckbox-italicSublabel',
            props.italicSublabel,
            true
          )}
        {props.schoolDefault &&
          renderCheckboxSubtextComponent(
            'GroupOptionsCheckbox-schoolDefault',
            `School default: ${props.schoolDefault}`,
            true
          )}
      </Checkbox>
    </Row>
  );
};

export default GroupOptionsCheckbox;
